/**
 * The workspace the user works in (0025, W15 M9): originations, recruiting,
 * partnerships. Kept per browser and sent as `x-ardley-workspace` on every
 * BFF call; the BFF checks the user may open it.
 */
export const WORKSPACE_STORAGE_KEY = "ardley-crm.workspace";
const DEFAULT_WORKSPACE = "originations";

export function getWorkspace(): string {
  if (typeof window === "undefined") return DEFAULT_WORKSPACE;
  const stored = window.localStorage.getItem(WORKSPACE_STORAGE_KEY);
  return stored && /^[a-z][a-z0-9-]*$/.test(stored)
    ? stored
    : DEFAULT_WORKSPACE;
}

export function setWorkspace(slug: string) {
  window.localStorage.setItem(WORKSPACE_STORAGE_KEY, slug);
}

export function clearWorkspace() {
  window.localStorage.removeItem(WORKSPACE_STORAGE_KEY);
}
